import { c as _c } from "react/compiler-runtime";
import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './MessageBox.module.css';
export enum MessageBoxType {
  Info = 'info',
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
}
export type MessageBoxProps = ComponentProps<'div'> & {
  type?: MessageBoxType;
};
export const MessageBox: FunctionComponent<MessageBoxProps> = React.memo(props => {
  const $ = _c(8);
  let children;
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      className,
      type: t2,
      children: t3,
      ...remainingProps
    } = prepareProps({
      props
    });
    children = t3;
    const type = t2 === undefined ? MessageBoxType.Info : t2;
    t0 = remainingProps;
    t1 = classes(className, styles.messageBox, messageBoxTypeToClassName[type]);
    $[0] = props;
    $[1] = children;
    $[2] = t0;
    $[3] = t1;
  } else {
    children = $[1];
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t0 || $[6] !== t1) {
    t2 = <div {...t0} className={t1}>{children}</div>;
    $[4] = children;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
});
const messageBoxTypeToClassName: Record<MessageBoxType, string | null> = {
  error: styles.messageBoxError,
  info: styles.messageBoxInfo,
  warning: styles.messageBoxWarning,
  success: styles.messageBoxSuccess
};